var map = {
	"./american_football/player.vue": "9fd3",
	"./badminton/player.vue": "341a",
	"./baseball/player.vue": "4791",
	"./basketball/player.vue": "3e8e",
	"./cricket/player.vue": "d15c",
	"./football/player.vue": "69f1",
	"./handball/player.vue": "86f1",
	"./ice_hockey/player.vue": "177a",
	"./snooker/player.vue": "e650",
	"./table_tennis/player.vue": "aee6",
	"./tennis/player.vue": "2da8",
	"./volleyball/player.vue": "c591",
	"./waterpolo/player.vue": "636a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0259";